import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    addStreetAddition: 'Add address line',
    clear: 'Clear',
    continue: 'Confirm my address',
    inputs: {
      city: {
        label: 'City',
      },
      legalName: {
        label: "Company's Legal Name",
      },
      street: {
        errors: {
          limitedLength: 'The street cannot have more than {0} characters',
        },
        label: 'Business Address',
        placeholder: 'Search your company’s address',
      },
      streetAddition: {
        label: 'Address second line',
        placeholder: 'Building, stair, floor...',
      },
      tradeName: {
        label: 'Trade Name (optional)',
      },
      zip: {
        errors: {
          invalid: 'The zip code should contain 5 digits',
        },
        label: 'Zip',
      },
    },
    save: 'Save',
    title: {
      add: 'Complete your company’s identity information',
      edit: 'Modify your company’s identity information',
    },
  },
  fr: {
    addStreetAddition: 'Ajouter un complément d’adresse',
    clear: 'Effacer',

    continue: 'Confirmer mon adresse',
    inputs: {
      city: {
        label: 'Ville',
      },
      legalName: {
        label: 'Nom légal de l’entreprise',
      },
      street: {
        errors: {
          limitedLength: 'La rue ne peut pas dépasser {0} caractères',
        },
        label: 'Adresse postale de l’entreprise',
        placeholder: 'Rechercher l’adresse de votre entreprise',
      },
      streetAddition: {
        label: 'Complément d’adresse',
        placeholder: 'Batiment, escalier, étage...',
      },
      tradeName: {
        label: 'Nom commercial (Optionnel)',
      },
      zip: {
        errors: {
          invalid: 'Le code postal doit comporter 5 chiffres',
        },
        label: 'Code postal',
      },
    },
    save: 'Enregistrer',
    title: {
      add: 'Compléter la fiche d’identité de votre entreprise',
      edit: 'Modifier la fiche d’identité de votre entreprise',
    },
  },
} as const);
